import { useState } from "react";
import { useParams } from "react-router-dom";

import { Card, Button, Flex, Modal, App } from "antd";

import PlusIcon from "@/icons/PlusIcon";

import DefinitionFieldsTable from "@/components/tables/DefinitionFieldsTable";
import DefinitionFieldModal from "@/components/modals/DefinitionFieldModal";

import { FIELDS_TITLES } from "@/constants/definitions";

import { deleteField } from "@/api/definitionFields";

const Fields = ({ fields, definition, onChangeObject }) => {
  const { message } = App.useApp();
  const { type, id } = useParams();

  const [isModalShow, setIsModalShow] = useState(false);
  const [modalItem, setModalItem] = useState();

  const handleAddField = () => {
    setModalItem(null);
    setIsModalShow(true);
  };

  const handleEditField = (item) => {
    setModalItem(item);
    setIsModalShow(true);
  };

  const handleSaveField = () => {
    setIsModalShow(false);
    onChangeObject();
  };

  const handleDeleteField = (item) => {
    if (item.uuid === definition?.nspd_cadastral_field_uuid?.uuid) {
      Modal.warning({
        title: "Поле нельзя удалить",
        content:
          "Это поле выбрано как поле кадастрового номера для актуализации данных из НСПД. Чтобы удалить поле, сначала отключите актуализацию из НСПД или выберите другое поле кадастрового номера.",
        okText: "Понятно",
      });

      return;
    }

    Modal.confirm({
      title: `Вы уверены, что хотите удалить поле ${item.name}?`,
      content:
        "Удаление поля приведет к его удалению из всех представлений, где оно используется. Это действие необратимо.",
      onOk() {
        handleConfirmDelete(item);
      },
      okText: "Удалить",
      cancelText: "Отмена",
    });
  };

  // Действительно удаляем сотрудника после подтверждения
  const handleConfirmDelete = async (item) => {
    try {
      await deleteField({ uuid: item.uuid });
      onChangeObject();
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    }
  };

  return (
    <>
      <Card
        title={FIELDS_TITLES[type]}
        extra={
          <Button
            type="primary"
            icon={<PlusIcon />}
            onClick={handleAddField}
          ></Button>
        }
      >
        <Flex vertical gap={20}>
          <DefinitionFieldsTable
            data={fields}
            pagination={false}
            isNSPD={!!definition?.is_nspd_enabled}
            onEditItem={handleEditField}
            onDeleteItem={handleDeleteField}
          />
        </Flex>
      </Card>

      {isModalShow && (
        <DefinitionFieldModal
          data={modalItem}
          definitionId={id}
          visible={isModalShow}
          useNSPD={definition?.is_nspd_enabled}
          nspdKeyCategoryUuid={definition?.nspd_category_uuid}
          onSave={handleSaveField}
          onCancel={() => setIsModalShow(false)}
        />
      )}
    </>
  );
};

export default Fields;
